export default {
  // Auth Endpoints
  fetchClientGroupsEndpoint: '/client-groups',
  sharedBlogsEndpoint: '/blogs',
  sharedFaqsEndpoint: '/faqs',
  sharedTestimonialsEndpoint: "/testimonials",
  sharedLoanSettings: "/loan-settings"
}
